import { CacheLocation } from "@auth0/auth0-spa-js";

export enum EnvironmentEnum {
  DEVELOPMENT = 0,
  LOCAL,
  PRODUCTION,
  TEST
}

export interface IAuth {
  domain: string;
  clientId: string;
  authorizationParams: {
    audience: string;
    redirect_uri: string;
  }
  cacheLocation?: CacheLocation,
}

export interface IEnvironment {
  auth: IAuth;
  httpInterceptor: {
    allowedList: Array<string>,
  }
  environment: EnvironmentEnum;
  environmentName: string;
  bearerToken: string;
  version: string;

  operatorApiEndpoint: string;
  sourcingServiceEndpoint: string;
  aircraftServiceEndpoint: string,
  consoleSiteUrl?: string;
  jetStudioSiteUrl?: string;
  allowE2eAuth?: boolean;
}
